export default {"src":"__ASTRO_ASSET_IMAGE__BhsKc01u__","width":72,"height":72,"format":"webp"}